export function isFlagEnabled(value) {
    return value === true || value === 1 || value === '1';
}

export function filterPricesByFlag(prices, flag) {
    if (!Array.isArray(prices)) {
        return [];
    }

    return prices.filter(price => price && typeof price === 'object' && isFlagEnabled(price[flag]));
}
